window.Products.Clothing.YouthLeggings10to12years = function() {};

window.Products.Clothing.YouthLeggings10to12years.inherits(window.Products.Clothing.YouthLeggings);
window.Products.Clothing.YouthLeggings10to12years.has_3d = true;
window.Products.Clothing.YouthLeggings10to12years.id = '60-10to12years';
window.Products.Clothing.YouthLeggings10to12years.saveId = 60;
window.Products.Clothing.YouthLeggings10to12years.slug = 'youth-leggings-10to12years';
window.Products.Clothing.YouthLeggings10to12years.dpi = 150;